
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35239',
  depVersions: {
  "documents-public-ui": "static-1.35239",
  "atom": "static-1.5403",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2798",
  "client-types": "static-1.498",
  "cssUtils": "static-1.938",
  "customer-data-filters-ui": "static-1.40966",
  "customer-data-objects": "static-1.8009",
  "customer-data-property-utils": "static-1.8418",
  "documents-lib": "static-1.35244",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.369",
  "FormsCommonComponents": "static-1.86579",
  "FormUrlGenerator": "static-2.5043",
  "foundations-theming-specialty": "static-1.2507",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5911",
  "hs-test-utils": "static-1.8349",
  "hub-http": "static-1.6530",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12112",
  "HubStyleTokens": "static-2.11805",
  "I18n": "static-7.1676",
  "icons": "static-2.685",
  "jasmine-immutable": "static-1.3338",
  "jasmine-runner": "static-1.6767",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7469",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3209",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5711",
  "quartz": "static-1.7475",
  "react": "static-7.196",
  "react-dlb": "static-1.89",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5566",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8497",
  "reference-resolvers-lite": "static-1.8419",
  "reporting-data": "static-1.68862",
  "reporting-reports": "static-1.68539",
  "reporting-snowflake": "static-1.57479",
  "reporting-testing-lib": "static-1.10795",
  "reporting-visualizations": "static-1.60937",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9267",
  "sanitize": "static-1.4788",
  "sanitize-text": "static-1.8472",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2061",
  "signup-constants": "static-1.19649",
  "signup-ui-url-generator": "static-2.8377",
  "StyleGuideUI": "static-3.503",
  "superstore": "static-1.5074",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5076",
  "ui-addon-form-validation": "static-1.11298",
  "ui-asset-management-lib": "static-1.11414",
  "ui-images": "static-2.1252",
  "UIComponents": "static-3.8751",
  "usage-tracker": "static-1.7637",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "viral-links-lib": "static-1.7393",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9973",
  "foundations-components": "static-1.8513",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1253",
  "quartz-core": "static-1.6694",
  "quick-fetch": "static-1.4139",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.4982",
  "ui-addon-i18n": "static-1.11463",
  "ui-addon-upgrades": "static-9.18401",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3631",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3752",
  "quartz-webpack": "static-1.3699",
  "foundations-assets": "static-1.5201",
  "foundations-theming": "static-1.4791",
  "hub-http-janus": "static-1.883",
  "sassPrefix": "static-1.207",
  "conversations-skeleton-state": "static-1.7564",
  "crm-message-bus": "static-1.43787",
  "customer-data-filters-ui-msw-helpers": "static-1.23401",
  "customer-data-objects-ui-components": "static-1.13346",
  "customer-data-reference-ui-components": "static-1.13493",
  "customer-data-ui-utilities": "static-1.10146",
  "events-data-lib": "static-1.562",
  "framework-builder-read-service-client": "static-1.4230",
  "hs-resources": "static-1.507",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4064",
  "multi-account-reference-resolvers": "static-1.1322",
  "onboarding-scopes": "static-1.6768",
  "onboarding-tours": "static-1.17132",
  "pulse": "static-1.945",
  "reporting-datasets-permissions-lib": "static-1.14487",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2676",
  "trellis-components": "static-1.2695",
  "trellis-theming": "static-1.1290",
  "ui-addon-teams": "static-1.21923",
  "quartz-auth": "static-1.1150",
  "usage-tracker-session-replay": "static-1.5323",
  "ai-components-ui-library": "static-1.9744",
  "ContentUtils": "static-1.69146",
  "customer-data-properties": "static-1.52634",
  "forms-ai-lib": "static-1.4778",
  "forms-utils-lib": "static-1.13109",
  "foundations-components-test-utils": "static-1.5996",
  "react-dnd-compat": "static-1.4932",
  "react-tinymce": "static-1.56003",
  "tinymce-config": "static-2.55129",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3776",
  "HeadJS": "static-2.798",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3460",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.304",
  "ui-fonts": "static-1.1067",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4629",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1140",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1860",
  "external-options-client-types": "static-1.4348",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7208",
  "quartz-i18n": "static-1.1150",
  "frontend-preferences-client": "static-1.8237",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4017",
  "reporting-client-types": "static-1.2699",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26206",
  "hubspot-apollo-client": "static-1.5193",
  "foundations-components-legacy": "static-1.1538",
  "quartz-routing": "static-1.905",
  "hs-story-utils": "static-1.9740",
  "react-flip-move": "static-1.78",
  "hubspotter-http": "static-1.4872",
  "nested-table": "static-1.550",
  "seat-types-lib": "static-1.754",
  "timezone-utils": "static-2.5560",
  "react-create-root-preference": "static-1.73",
  "bend-plugin-foundations-components": "static-1.4782",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.87",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.578",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.462",
  "quartz-test": "static-1.1150",
  "quartz-tracking": "static-1.854",
  "bend-plugin-chirp-manifest": "static-1.392",
  "chirp-fetch": "static-1.2211",
  "merchandise-lib": "static-1.278",
  "purchase-motions-components": "static-1.6381",
  "salesImages": "static-1.579",
  "ts-schema": "static-1.4304",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3274",
  "restore-request-side-panel-lib": "static-1.1700",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4972",
  "conditional-properties-service-client": "static-1.4025",
  "crm-pipelines-api-client-types": "static-1.4358",
  "event-emitter": "static-1.1269",
  "fdsr-migration-layer": "static-1.327",
  "multi-currency-client-types": "static-1.3918",
  "getting-started-shared-tasks": "static-1.19266",
  "growth-data-modal": "static-1.5914",
  "growth-onboarding-confetti": "static-1.3377",
  "growth-onboarding-next-action-utils": "static-1.2710",
  "navigation-components": "static-1.18860",
  "onboarding-tours-client": "static-1.5347",
  "onboarding-tours-utils": "static-1.1199",
  "ui-shepherd-react": "static-3.10586",
  "ui-shepherd-tracker": "static-1.7967",
  "ui-universal-auth": "static-1.9423",
  "user-context": "static-1.5436",
  "bend-plugin-pulse": "static-1.448",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.143",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hub-http-shared-msw-handlers": "static-1.10639",
  "hubspotter-http-shared-msw-handlers": "static-1.10637",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23084",
  "copilot-toolkit": "static-1.11865",
  "cms-field-types": "static-1.5131",
  "content-icons-ui": "static-1.2380",
  "integrations-lib": "static-1.17066",
  "calling-global-api": "static-1.65655",
  "calling-internal-common": "static-1.31638",
  "calling-lifecycle-internal": "static-1.67037",
  "calling-lifecycle-messages": "static-1.59331",
  "commerce-products-lib": "static-1.10554",
  "crm-index-visualization-core": "static-1.4558",
  "crm-links": "static-1.6647",
  "customer-data-properties-shared-msw-handlers": "static-1.9966",
  "file-manager-components": "static-1.24525",
  "formula-editor": "static-1.14784",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4437",
  "meetings-icalendar-utils-lib": "static-1.952",
  "object-builder-ui-client": "static-1.49704",
  "pipeline-validation-client-types": "static-1.4191",
  "property-value-citations": "static-1.3248",
  "smart-data-capture-core": "static-1.161",
  "smart-property-lib": "static-1.8321",
  "tiered-pricing": "static-1.1975",
  "topics-actions-lib": "static-1.484",
  "trial-components-library": "static-1.14124",
  "ui-addon-iframeable": "static-1.9394",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20322",
  "tinymce-themes": "static-1.57099",
  "data-token-picker": "static-1.16905",
  "hub-http-contrib": "static-1.3355",
  "interframe": "static-3.5071",
  "tinymce-data": "static-1.41214",
  "tinymce-plugins": "static-1.58243",
  "ui-addon-sales-email": "static-1.5529",
  "framework-data-schema-quick-fetch": "static-1.7113",
  "ui-addon-opt": "static-4.8680",
  "hubspot-apollo-cache": "static-1.652",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.466",
  "opentelemetry-web": "static-1.13",
  "purchase-motions-api": "static-1.6384",
  "onboarding-data-sync-lib": "static-1.2530",
  "growth-onboarding-next-action-components": "static-1.2738",
  "user-context-client": "static-1.4822",
  "idb-keyval": "static-1.51",
  "magpie-lib": "static-1.5768",
  "magpie-types": "static-1.5228",
  "nest": "static-1.552",
  "reactive-lib": "static-1.1034",
  "simple-logging-lib": "static-1.3367",
  "unified-auth-core-lib": "static-1.1219",
  "getting-started-shared-tasks-store": "static-1.18384",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1773",
  "integrations-error-boundary-lib": "static-1.14481",
  "integrations-tracking-lib": "static-1.5924",
  "native-integrations-shared-strings": "static-1.8093",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10687",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.937",
  "calling-error-reporting": "static-1.31645",
  "shared-worker-versioning": "static-1.11358",
  "voice-sms-access-library": "static-1.2085",
  "commerce-permissions": "static-1.1093",
  "products-iframe-lib": "static-1.8608",
  "crm-index-associations-lib": "static-1.6757",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10722",
  "sales-views-client-types": "static-1.4572",
  "location-customization-utils-lib": "static-1.10121",
  "immerable": "static-1.4464",
  "video-components-external": "static-1.12169",
  "video-data-lib": "static-1.35827",
  "bark-lib": "static-1.16829",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6205",
  "react-codemirror": "static-1.10957",
  "data-agent-kit": "static-1.665",
  "feedback-loader": "static-1.29828",
  "fsm": "static-1.4066",
  "policy-lib": "static-1.7118",
  "react-colorpicker": "static-2.10533",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10785",
  "customer-data-tracking": "static-1.7198",
  "embedded-academy-lib": "static-1.15555",
  "hubs-service-types": "static-1.1575",
  "navigation-messaging": "static-1.8187",
  "FileManagerLib": "static-1.40165",
  "NamespacedHubStyle": "static-2.9274",
  "FileManagerCore": "static-1.40024",
  "content-assistance-lib": "static-1.8216",
  "layout-dnd-components": "static-1.12987",
  "layout-dnd-utils": "static-1.11962",
  "ui-addon-emoji-picker": "static-1.10201",
  "ui-brand-identity-lib": "static-1.16535",
  "InboxConnectUtils": "static-4.15580",
  "meetings-connect-utils-lib": "static-1.7925",
  "breeze-engine-chat-components": "static-1.751",
  "breeze-engine-core": "static-1.1051",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3325",
  "adobe-sign-auth-lib": "static-1.484",
  "ads-unified-auth-lib": "static-1.1450",
  "generic-oauth-auth-lib": "static-1.65",
  "google-sheets-integration-lib": "static-1.1051",
  "microsoft-drive-auth-lib": "static-1.168",
  "surveymonkey-integration-lib": "static-1.510",
  "slack-ui-library": "static-1.10714",
  "calling-orchestration-schema": "static-1.36862",
  "crm-record-cards-service-types": "static-1.3796",
  "apollo-dlb": "static-3.86",
  "content-media-composition-data-lib": "static-1.13269",
  "content-media-compositions": "static-2.17276",
  "media-bridge-lib": "static-1.19422",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16386",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4824",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.15015",
  "FileManagerImages": "static-1.37676",
  "video-components": "static-1.14171",
  "breeze-artifacts-sdk": "static-1.381",
  "audio-components": "static-1.6361",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4849",
  "video-embed": "static-1.36661",
  "ui-addon-video-player": "static-1.9020",
  "ui-coaching-tips": "static-1.29330",
  "ContentData": "static-1.69221",
  "layout-data-lib": "static-1.10287",
  "academy-service-client": "static-1.4006",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4720",
  "trellis-ecosystem": "static-1.7644",
  "ui-addon-react-router-dom": "static-1.9851",
  "wootric-nps": "static-1.7210",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4470",
  "growth-onboarding-feedback-components": "static-1.6900",
  "advanced-menus-core": "static-1.15593",
  "ExportDialog": "static-6.10693",
  "ui-memberships-settings-lib": "static-1.34866",
  "marketplace-ui-apps-core": "static-1.19290",
  "marketplace-ui-common": "static-1.20758",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15592",
  "settings-ui-lib": "static-1.12841",
  "developer-experience-shared-components": "static-1.10856",
  "immutable-less": "static-1.4966",
  "marketplace-ui-client-types": "static-1.18165",
  "ui-addon-integrations-directory-panel": "static-2.8343",
  "ui-extensibility-client-types": "static-1.4234",
  "ai-settings-ui-library": "static-1.8363",
  "nav-meta": "static-1.30497",
  "ui-product-approvals-common": "static-1.1102",
  "apps-service-types": "static-1.4056",
  "oauth-service-types": "static-1.4551",
  "simple-data-table": "static-1.3541"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35239",
  "atom": "/atom/static-1.5403",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2798",
  "client-types": "/client-types/static-1.498",
  "cssUtils": "/cssUtils/static-1.938",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40966",
  "customer-data-objects": "/customer-data-objects/static-1.8009",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8418",
  "documents-lib": "/documents-lib/static-1.35244",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.369",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86579",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5043",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2507",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5911",
  "hs-test-utils": "/hs-test-utils/static-1.8349",
  "hub-http": "/hub-http/static-1.6530",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12112",
  "HubStyleTokens": "/HubStyleTokens/static-2.11805",
  "I18n": "/I18n/static-7.1676",
  "icons": "/icons/static-2.685",
  "jasmine-immutable": "/jasmine-immutable/static-1.3338",
  "jasmine-runner": "/jasmine-runner/static-1.6767",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7469",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3209",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5711",
  "quartz": "/quartz/static-1.7475",
  "react": "/react/static-7.196",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5566",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8497",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8419",
  "reporting-data": "/reporting-data/static-1.68862",
  "reporting-reports": "/reporting-reports/static-1.68539",
  "reporting-snowflake": "/reporting-snowflake/static-1.57479",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10795",
  "reporting-visualizations": "/reporting-visualizations/static-1.60937",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9267",
  "sanitize": "/sanitize/static-1.4788",
  "sanitize-text": "/sanitize-text/static-1.8472",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2061",
  "signup-constants": "/signup-constants/static-1.19649",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8377",
  "StyleGuideUI": "/StyleGuideUI/static-3.503",
  "superstore": "/superstore/static-1.5074",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5076",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11298",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11414",
  "ui-images": "/ui-images/static-2.1252",
  "UIComponents": "/UIComponents/static-3.8751",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "viral-links-lib": "/viral-links-lib/static-1.7393",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9973",
  "foundations-components": "/foundations-components/static-1.8513",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1253",
  "quartz-core": "/quartz-core/static-1.6694",
  "quick-fetch": "/quick-fetch/static-1.4139",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.4982",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11463",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18401",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3631",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3752",
  "quartz-webpack": "/quartz-webpack/static-1.3699",
  "foundations-assets": "/foundations-assets/static-1.5201",
  "foundations-theming": "/foundations-theming/static-1.4791",
  "hub-http-janus": "/hub-http-janus/static-1.883",
  "sassPrefix": "/sassPrefix/static-1.207",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7564",
  "crm-message-bus": "/crm-message-bus/static-1.43787",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23401",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13346",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13493",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10146",
  "events-data-lib": "/events-data-lib/static-1.562",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4230",
  "hs-resources": "/hs-resources/static-1.507",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4064",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1322",
  "onboarding-scopes": "/onboarding-scopes/static-1.6768",
  "onboarding-tours": "/onboarding-tours/static-1.17132",
  "pulse": "/pulse/static-1.945",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14487",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2676",
  "trellis-components": "/trellis-components/static-1.2695",
  "trellis-theming": "/trellis-theming/static-1.1290",
  "ui-addon-teams": "/ui-addon-teams/static-1.21923",
  "quartz-auth": "/quartz-auth/static-1.1150",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9744",
  "ContentUtils": "/ContentUtils/static-1.69146",
  "customer-data-properties": "/customer-data-properties/static-1.52634",
  "forms-ai-lib": "/forms-ai-lib/static-1.4778",
  "forms-utils-lib": "/forms-utils-lib/static-1.13109",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5996",
  "react-dnd-compat": "/react-dnd-compat/static-1.4932",
  "react-tinymce": "/react-tinymce/static-1.56003",
  "tinymce-config": "/tinymce-config/static-2.55129",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3776",
  "HeadJS": "/HeadJS/static-2.798",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3460",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.304",
  "ui-fonts": "/ui-fonts/static-1.1067",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4629",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1140",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1860",
  "external-options-client-types": "/external-options-client-types/static-1.4348",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7208",
  "quartz-i18n": "/quartz-i18n/static-1.1150",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8237",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4017",
  "reporting-client-types": "/reporting-client-types/static-1.2699",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26206",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5193",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1538",
  "quartz-routing": "/quartz-routing/static-1.905",
  "hs-story-utils": "/hs-story-utils/static-1.9740",
  "react-flip-move": "/react-flip-move/static-1.78",
  "hubspotter-http": "/hubspotter-http/static-1.4872",
  "nested-table": "/nested-table/static-1.550",
  "seat-types-lib": "/seat-types-lib/static-1.754",
  "timezone-utils": "/timezone-utils/static-2.5560",
  "react-create-root-preference": "/react-create-root-preference/static-1.73",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4782",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.87",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.578",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.462",
  "quartz-test": "/quartz-test/static-1.1150",
  "quartz-tracking": "/quartz-tracking/static-1.854",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.392",
  "chirp-fetch": "/chirp-fetch/static-1.2211",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "purchase-motions-components": "/purchase-motions-components/static-1.6381",
  "salesImages": "/salesImages/static-1.579",
  "ts-schema": "/ts-schema/static-1.4304",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3274",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1700",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4972",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4025",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4358",
  "event-emitter": "/event-emitter/static-1.1269",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.327",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3918",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19266",
  "growth-data-modal": "/growth-data-modal/static-1.5914",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3377",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2710",
  "navigation-components": "/navigation-components/static-1.18860",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5347",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1199",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10586",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7967",
  "ui-universal-auth": "/ui-universal-auth/static-1.9423",
  "user-context": "/user-context/static-1.5436",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.448",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.143",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10639",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10637",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23084",
  "copilot-toolkit": "/copilot-toolkit/static-1.11865",
  "cms-field-types": "/cms-field-types/static-1.5131",
  "content-icons-ui": "/content-icons-ui/static-1.2380",
  "integrations-lib": "/integrations-lib/static-1.17066",
  "calling-global-api": "/calling-global-api/static-1.65655",
  "calling-internal-common": "/calling-internal-common/static-1.31638",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67037",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59331",
  "commerce-products-lib": "/commerce-products-lib/static-1.10554",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4558",
  "crm-links": "/crm-links/static-1.6647",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9966",
  "file-manager-components": "/file-manager-components/static-1.24525",
  "formula-editor": "/formula-editor/static-1.14784",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4437",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.952",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49704",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4191",
  "property-value-citations": "/property-value-citations/static-1.3248",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.161",
  "smart-property-lib": "/smart-property-lib/static-1.8321",
  "tiered-pricing": "/tiered-pricing/static-1.1975",
  "topics-actions-lib": "/topics-actions-lib/static-1.484",
  "trial-components-library": "/trial-components-library/static-1.14124",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9394",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20322",
  "tinymce-themes": "/tinymce-themes/static-1.57099",
  "data-token-picker": "/data-token-picker/static-1.16905",
  "hub-http-contrib": "/hub-http-contrib/static-1.3355",
  "interframe": "/interframe/static-3.5071",
  "tinymce-data": "/tinymce-data/static-1.41214",
  "tinymce-plugins": "/tinymce-plugins/static-1.58243",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5529",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7113",
  "ui-addon-opt": "/ui-addon-opt/static-4.8680",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.652",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.466",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "purchase-motions-api": "/purchase-motions-api/static-1.6384",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2530",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2738",
  "user-context-client": "/user-context-client/static-1.4822",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-lib": "/magpie-lib/static-1.5768",
  "magpie-types": "/magpie-types/static-1.5228",
  "nest": "/nest/static-1.552",
  "reactive-lib": "/reactive-lib/static-1.1034",
  "simple-logging-lib": "/simple-logging-lib/static-1.3367",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1219",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18384",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1773",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14481",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5924",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8093",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10687",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.937",
  "calling-error-reporting": "/calling-error-reporting/static-1.31645",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11358",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2085",
  "commerce-permissions": "/commerce-permissions/static-1.1093",
  "products-iframe-lib": "/products-iframe-lib/static-1.8608",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6757",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10722",
  "sales-views-client-types": "/sales-views-client-types/static-1.4572",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10121",
  "immerable": "/immerable/static-1.4464",
  "video-components-external": "/video-components-external/static-1.12169",
  "video-data-lib": "/video-data-lib/static-1.35827",
  "bark-lib": "/bark-lib/static-1.16829",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6205",
  "react-codemirror": "/react-codemirror/static-1.10957",
  "data-agent-kit": "/data-agent-kit/static-1.665",
  "feedback-loader": "/feedback-loader/static-1.29828",
  "fsm": "/fsm/static-1.4066",
  "policy-lib": "/policy-lib/static-1.7118",
  "react-colorpicker": "/react-colorpicker/static-2.10533",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10785",
  "customer-data-tracking": "/customer-data-tracking/static-1.7198",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15555",
  "hubs-service-types": "/hubs-service-types/static-1.1575",
  "navigation-messaging": "/navigation-messaging/static-1.8187",
  "FileManagerLib": "/FileManagerLib/static-1.40165",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9274",
  "FileManagerCore": "/FileManagerCore/static-1.40024",
  "content-assistance-lib": "/content-assistance-lib/static-1.8216",
  "layout-dnd-components": "/layout-dnd-components/static-1.12987",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11962",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10201",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16535",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15580",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7925",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.751",
  "breeze-engine-core": "/breeze-engine-core/static-1.1051",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3325",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.484",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1450",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.65",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1051",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.168",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.510",
  "slack-ui-library": "/slack-ui-library/static-1.10714",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36862",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13269",
  "content-media-compositions": "/content-media-compositions/static-2.17276",
  "media-bridge-lib": "/media-bridge-lib/static-1.19422",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16386",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4824",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.15015",
  "FileManagerImages": "/FileManagerImages/static-1.37676",
  "video-components": "/video-components/static-1.14171",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.381",
  "audio-components": "/audio-components/static-1.6361",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4849",
  "video-embed": "/video-embed/static-1.36661",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9020",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29330",
  "ContentData": "/ContentData/static-1.69221",
  "layout-data-lib": "/layout-data-lib/static-1.10287",
  "academy-service-client": "/academy-service-client/static-1.4006",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4720",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7644",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9851",
  "wootric-nps": "/wootric-nps/static-1.7210",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4470",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6900",
  "advanced-menus-core": "/advanced-menus-core/static-1.15593",
  "ExportDialog": "/ExportDialog/static-6.10693",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34866",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19290",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20758",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15592",
  "settings-ui-lib": "/settings-ui-lib/static-1.12841",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10856",
  "immutable-less": "/immutable-less/static-1.4966",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18165",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8343",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4234",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8363",
  "nav-meta": "/nav-meta/static-1.30497",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1102",
  "apps-service-types": "/apps-service-types/static-1.4056",
  "oauth-service-types": "/oauth-service-types/static-1.4551",
  "simple-data-table": "/simple-data-table/static-1.3541"
}
};
